export default "__VITE_ASSET__D3_$qUp8__"